import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { CmsService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subscription } from 'rxjs';
import { CustomAddToCartService } from '../custom-add-to-cart.service';

@Component({
    selector: 'app-custom-add-to-cart',
    templateUrl: './custom-add-to-cart.component.html',
    styleUrls: ['./custom-add-to-cart.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CustomAddToCartComponent implements OnInit, OnDestroy {
  templatePage: any;
  childCarts: boolean;
  cartId: any;
  userAccountgetData: any;
  cartItems: any;
  private subscriptions = new Subscription();
  constructor(
    private readonly pageDate: CmsService,
    private readonly addToCart: CustomAddToCartService,
    private readonly user: UserAccountFacade,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.childCarts = false;
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.pageDate.getCurrentPage().subscribe((res) => {
        if (res) {
          this.templatePage = res?.template;
        }
        this.cdr.detectChanges();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
